import { ReactElement, useContext } from "react";
import { IntercomWrapper } from "./IntercomWrapper";
import { GuestAuthenticationContext } from "../contexts/guest-auth-context/GuestAuthContext";

export function IntercomWrapperGuest(props: {children: ReactElement | ReactElement[]}): ReactElement {
    const {user} = useContext(GuestAuthenticationContext);
    return <IntercomWrapper user={user === null ? null : {...user, custom_tag: "guest_user"}} {...props}/>;
}